export const setConstants = constants => ({
    type: 'SET_CONSTANTS',
    constants
});